import React from "react";

import { MiniStatBox } from "@/components/atoms";
import { AudienceSummary } from "@/types";
import { abbreviateNumber } from "@/utils";
import { House, PeopleAlt, Place } from "@mui/icons-material";
import { SvgIconProps } from "@mui/material";
import Grid from "@mui/material/Grid2";

interface AudienceMiniStatsProps {
  audienceSize: AudienceSummary;
  audienceGrowth?: AudienceSummary;
  size?: "small" | "medium";
  color?: SvgIconProps["color"];
  shrink?: boolean;
  justifyContent?: "flex-start" | "center" | "flex-end"
}

export const AudienceMiniStats: React.FC<AudienceMiniStatsProps> = ({
  audienceSize,
  audienceGrowth,
  size = "medium",
  color = "secondary",
  shrink = false,
  justifyContent = "flex-end"
}) => {
  return (
    <Grid
      size={shrink && 12}
      display="flex"
      flexDirection={
        shrink ?
          {
            sm: "column",
            md: "column",
            lg: "column",
            xl: "row",
          }
        : "row"
      }
      justifyContent={justifyContent}
      gap={size === "small" ? 1 : 2}
    >
      {audienceSize.num_postcodes !== undefined && (
        <MiniStatBox
          name="Postcodes"
          value={audienceSize.num_postcodes}
          growth={audienceGrowth && audienceGrowth.num_postcodes}
          valueFormatter={abbreviateNumber}
          icon={<Place fontSize="small" color={color} />}
          size={size}
        />
      )}
      {audienceSize.num_sectors !== undefined && (
        <MiniStatBox
          name="Sectors"
          value={audienceSize.num_sectors}
          growth={audienceGrowth && audienceGrowth.num_sectors}
          valueFormatter={abbreviateNumber}
          icon={<Place fontSize="small" color={color} />}
          size={size}
        />
      )}
      {audienceSize.num_households !== undefined && (
        <MiniStatBox
          name="Households"
          value={audienceSize.num_households}
          growth={audienceGrowth && audienceGrowth.num_households}
          valueFormatter={abbreviateNumber}
          icon={<House fontSize="small" color={color} />}
          size={size}
        />
      )}
      {audienceSize.population_count !== undefined && (
        <MiniStatBox
          name="Audience Size"
          value={audienceSize.population_count}
          growth={audienceGrowth && audienceGrowth.population_count}
          valueFormatter={abbreviateNumber}
          icon={<PeopleAlt fontSize="small" color={color} />}
          size={size}
        />
      )}
    </Grid>
  );
};

export default AudienceMiniStats;
